'use client';
function getBaseSize(size) {
  if (typeof size === "object") {
    return size.base;
  }
  return size;
}

export { getBaseSize };
//# sourceMappingURL=get-base-size.mjs.map
